module.exports = __webpack_public_path__ + "img/fm-f-Path 54@3x.937caec2.png";